import React from 'react';
import {
    Container,
    Grid,
    Typography,
    makeStyles
} from '@material-ui/core';
import Page from 'components/Page';
import { useTranslation } from "react-i18next";
import UserTable from './UserTable';

const useStyles = makeStyles((theme) => ({
    root: {
    }
}));

export default function UserListView() {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Page
            className={classes.root}
            title={t('navbar.users')}
        >
            <Container maxWidth={false}>
                <Typography variant="h1" gutterBottom >
                    {t('navbar.users')}
                </Typography>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <UserTable/>
                    </Grid>
                </Grid>
            </Container>
        </Page>
    );
}